module.exports = __webpack_public_path__ + "static/media/slajd-1.359b2343.jpg";